"use strict";

module.exports = {
  COHORT: 'COHORT' // people
};